import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'studio.AcaKEj',
    defaultMessage: 'OAuth2',
  },
  error: {
    id: 'studio.xkq49p',
    defaultMessage: 'There was a problem loading the OAuth2 secrets.',
  },
  loading: {
    id: 'studio.bvprIx',
    defaultMessage: 'Loading OAuth2 secrets…',
  },
  noSecrets: {
    id: 'studio.snSsXF',
    defaultMessage: 'No OAuth2 secrets have been configured yet.',
  },
  addNew: {
    id: 'studio.v9WChN',
    defaultMessage: 'Add new secret',
  },
});
